import type { ReactNode } from 'react'

import type { TPermissionKey, TPermissionsMap } from './permissions'
import { useIsGranted } from './useIsGranted'

export const RequiredRole = ({
  permission,
  permissionsMap,
  children,
  fallback,
}: {
  permission: TPermissionKey
  permissionsMap: TPermissionsMap
  fallback?: ReactNode
  children?: ReactNode
}): ReactNode => {
  const isGranted = useIsGranted(permission, permissionsMap)

  if (!isGranted) {
    return fallback || null
  }

  return children
}
